module.exports = __webpack_public_path__ + "newstatic/img/adtype-iphone.ed33978.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/adtype-iphone.png
// module id = yqDF
// module chunks = 1